import './navigationButtons.scss';
import * as React from 'react';
import { icons } from '../../content/icons';
import { RMButton } from '../layout/rmButton';
export const NavigationButtons = ({ onClickNext, onClickPrev, canGoNext, canGoPrev }) => (<>
    <RMButton className="navigation-button left" variant="lighten-bg" leftIcon={icons.left} data-hidden={!canGoPrev} onClick={onClickPrev} name="back"/>

    <RMButton className="navigation-button right" variant="lighten-bg" leftIcon={icons.right} data-hidden={!canGoNext} onClick={onClickNext} name="forwards"/>
  </>);
